// Alertas das tarefas: lista de itens (no início, minutos antes, hora fixa), compatível com o formato antigo.
import type { AlertaItem, Alerts } from '../store/types';
import { t } from './i18n';
import { horaTela } from './date';

/** Converte qualquer Alerts (antigo ou novo) para a lista de itens. */
export function alertItens(a?: Alerts | null): AlertaItem[] {
  if (!a) return [];
  if (Array.isArray(a.itens)) return a.itens;
  if (a.mode === 'start') return [{ tipo: 'inicio' }];
  if (a.mode === 'before') return (a.before ?? []).map(min => (min ? { tipo: 'antes', min } : { tipo: 'inicio' }));
  return [];
}

/** Monta o Alerts a partir da lista, preenchendo também mode/before para versões antigas do app. */
export function alertasDe(itens: AlertaItem[]): Alerts {
  const rel = itens.filter(i => i.tipo !== 'hora').map(i => (i.tipo === 'inicio' ? 0 : Math.max(0, i.min ?? 0)));
  const mode: Alerts['mode'] = !rel.length ? 'none' : rel.length === 1 && rel[0] === 0 ? 'start' : 'before';
  return { mode, before: mode === 'before' ? rel : [], itens };
}

export function alertaTexto(i: AlertaItem) {
  if (i.tipo === 'inicio' || (i.tipo === 'antes' && !i.min)) return t('No início');
  if (i.tipo === 'antes') return t('{n} min antes', { n: i.min ?? 0 });
  return t('Às {hora}', { hora: i.hora ? horaTela(i.hora) : '--:--' });
}

export const alertasResumo = (itens: AlertaItem[]) => (itens.length ? itens.map(alertaTexto).join(', ') : t('Sem alerta'));
